import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import {
  Button,
 
  CardBody,
  Col,
  Form,
 
  Label,
  Row,
  TabContent,
  TabPane,
  Modal,
  Alert
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert"
import Select from "react-select";

import { connect, useDispatch, useSelector} from "react-redux";
import { useParams, withRouter, Link,} from "react-router-dom";

import MySelect from "../../../components/test";






//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import { casosCreate } from  "../../../store/casos/actions"
import { grupotecnicoList } from "../../../store/grupoTecnico/actions";


import ListaCasos from "./ListaCasos";

const CasosContacto = (props) => {
  const param = useParams();
const dispatch= useDispatch();
const str = param.id; 
const contactoId = Number(str);
const user = JSON.parse(localStorage.getItem("user"));
const groups =String(user.groups);
const [activeTab, setActiveTab] = useState('1');

console.log(setActiveTab)

   
useEffect(() => {
  
 

  dispatch(grupotecnicoList())
 
  
  
},[dispatch]);


const grupotTecnico = useSelector(state => state.GrupoTecnico.grupotecnico.results) || []
const contact = useSelector(state => state.Contacts.contacts) || []

const contacto = contactoId;

const [caso, setCaso] = useState(false)
const [caso_txt, setCaso_txt] = useState("")
console.log(caso_txt)


const [selectedTipoVisita, setselectedTipoVisita] = useState(null)
const [selectedTipoServicio, setSelectedTipoServicio] = useState(null)

const [selectedGrupoTecnico, setSelectedGrupoTecnico] = useState(null)
const tipo_visita = selectedTipoVisita;
const tipo_servicio = selectedTipoServicio;


function handleSelectTipoVisita(selectedTipoVisita) {
  setselectedTipoVisita(selectedTipoVisita.value);

}
function handleSelectTipoServcio(selectedTipoServicio){
  setSelectedTipoServicio(selectedTipoServicio.value)
}
function handleSelectGrupoTecnico(selectedGrupoTecnico){
  setSelectedGrupoTecnico(selectedGrupoTecnico.value)
}
const grupo_tecnico = selectedGrupoTecnico;
const sd =  Array.isArray(contact) ? contact.filter(item => item.grupo_tecnico === grupo_tecnico) :[]

const handleAdd = () =>{ 
  
    setCaso(!caso);
  
   

}

const[formData, setFormData] = useState({
  observaciones:"",
  detallesServicio:"",
  tecnico_asignado:[],
  datosServicio:""
})

const {
  observaciones,
  detallesServicio,
  tecnico_asignado,
  datosServicio
} = formData

const onChange = (e) => {
  const uppercaseValue = e.target.value.toUpperCase()
  setFormData({ ...formData, [e.target.name]: uppercaseValue });
}


const [fechacalendario, setFechaAsignada] = useState(null);
    
const [horaEntrada, setHoraEntrada] = useState(null)

const [horaSalida, setHoraSalida] = useState(null)

let lapso_hora_entrada=''
let lapso_hora_salida=''

const onChangeFecha = ( e) => {
  
  setFechaAsignada( e.target.value);
 };

 const fecha_asignacion=fechacalendario


 const onChangeHoraEntrada = (e) => {
   if (e && e.target && e.target.value) {
     setHoraEntrada(e.target.value);
   }
 };
 
 
 

 let horaEntraRec = horaEntrada?.toString().slice(0,5)
 lapso_hora_entrada =horaEntraRec


 
 const onChangeHoraSalida = ( e) => {
   if (e && e.target && e.target.value) {
  setHoraSalida(e.target.value);
   }
 };
 
 let horaSalidaRec =  horaSalida?.toString().slice(0,5)
 lapso_hora_salida = horaSalidaRec


 
 const [image_file, setImage_file] = useState("")

 const handleImageChange  = (imagen) => {
   
   Array.from(imagen).forEach(image => {
    
     var reader = new FileReader()
     reader.readAsDataURL(image)
     reader.onload=function(){
       var img =[]
       var base64 = reader.result
       img=base64.split(',')
       setImage_file(img[1])
     }
   })
 }



const onSubmit = (e) => {
  e.preventDefault();
  props.casosCreate({
    contacto,
    tipo_visita,
    fecha_asignacion,
    lapso_hora_entrada,
    lapso_hora_salida,
    tecnico_asignado,
    tipo_servicio,
    observaciones,
    detallesServicio,
    grupo_tecnico,
    image_file,
    datosServicio
  });
  
 };


   //Options
   const TipoVisita = [
    {

      options: [
        { label: "VISITA CONTRATO", value: "VISITA CONTRATO" },
        { label: "VISITA ADICIONAL", value: "VISITA ADICIONAL" },
        { label: "VENTA", value: "VENTA" },
        { label: "GARANTIA", value: "GARANTIA" },
        { label: "REVISION O REPARACION", value: "REVISION O REPARACION" },
        { label: "ENTREGA", value: "ENTREGA" },
        { label: "LEVANTAMIENTO DE INFORMACION", value: "LEVANTAMIENTO DE INFORMACION" },
        { label: "MANTENIMIENTO PREVENTIVO", value: "MANTENIMIENTO PREVENTIVO" },
        { label: "MANTENIMIENTO CORRECTIVO", value: "MANTENIMIENTO CORRECTIVO" },
        { label: "MENSAJERIA", value: "MENSAJERIA" },
        { label: "COMPRAS", value: "COMPRAS" },
      ],
    },

  ];

  const TipoServicio= [
    {

      options: [
        { label: "PRESENCIAL", value: "PRESENCIAL" },
        { label: "REMOTO", value: "REMOTO" },
        { label: "MIXTO", value: "MIXTO" }
     
      ],
    },

  ];

  const handleReload = () => {
    window.location.reload();
  };



    return (  
      <React.Fragment>

              <Link
              className ="btn btn-info btn-sm mb-2 "
              to="/contacts">
                Volver
              </Link>{"  "}

              {props.casosCreated.id ? (
                            <SweetAlert
                              title="Hecho!"
                              success
                              timeout={1000}
                              showConfirm={false}
                              onConfirm={() => {
                                handleReload()
                              }}
                            >
                              Se ha agregado el Caso  con el numero {props.casosCreated.id}
                            </SweetAlert>
                          ) : null}


                {/* Modal de los Casos */}
              <Modal
            isOpen={caso}
            centered={true}
            toggle={()=> {setCaso_txt(""); setCaso(false)}}
            size="lg"

        >          
        <div className="modal-header">
        <h3 className="modal-title mt-2">
            Crear Caso
        </h3>
        <button
            type="button"
            onClick={() => {
              setCaso_txt("")
              setCaso(false);
                
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        </div>

        {/* Formulario de Casos */}
        <div className="modal-body">



                                <Form 
                                onSubmit={onSubmit}
                                >

                                  {/* Tipo de Visita */}
                                        <Row>

                                          <Label
                                                for="tipo_visita"
                                                className="form-label mt-2"
                                              >
                                                TIPOO DE VISITA
                                              </Label>
                                              <Select
                                              
                                                id="tipo_visita"
                                                name="tipo_visita"
                                                
                                                
                                                onChange={handleSelectTipoVisita}
                                                options={TipoVisita}
                                                autoFocus
                                
                                              />

                                                {props.error && props.error.tipo_visita ? (
                                                  <Alert color = 'danger' className="mt-2">{props.error.tipo_visita}</Alert>
                                                  ):null}
                                        </Row>


                                          {/* Tipo de Servicio */}

                                          <Row>

                                            <Label
                                                for="tipo_visita"
                                                className="form-label mt-2"
                                              >
                                                TIPO DE SERVICIO
                                              </Label>
                                              <Select
                                              
                                                id="tipo_servicio"
                                                name="tipo_servicio"
                                                
                                                options={TipoServicio}
                                                onChange={handleSelectTipoServcio}
                                                
                                                autoFocus
                                
                                              />

                                              {props.error && props.error.tipo_servicio ? (
                                                  <Alert color = 'danger' className="mt-2">{props.error.tipo_servicio}</Alert>
                                                  ):null}
                                          </Row>
                                          {/* Datos de Servicio */}

                                          <Row>

                                            <Label
                                                for="datosServicio"
                                                className="form-label mt-2"
                                              >
                                                DATOS DE SERVICIO
                                              </Label>
                                              <textarea
                                                            className="form-control"
                                                            id="datosServicio"
                                                            name="datosServicio"
                                                            type="textarea"
                                                            rows="2"
                                                            value={datosServicio}
                                                            onChange={onChange}
                                                            
                                                          
                                                            
                                                            
                                                          />
                                                              {props.error && props.error.datosServicio ? (
                                                      <Alert color = 'danger' className="mt-2">{props.error.datosServicio}</Alert>
                                                      ):null}
                                          </Row>


                                                  {/* Detalles del Servicio */}

                                                  <Row>

                                                                <Label
                                                            for="detallesServicio"
                                                            className="col-form-label col-sm-4 d-flex"
                                                          >
                                                        <strong>DETALLES DEL SERVICIO</strong> 
                                                          </Label>

                                                          <textarea
                                                            className="form-control"
                                                            id="detallesServicio"
                                                            name="detallesServicio"
                                                            type="textarea"
                                                            rows="2"
                                                            value={detallesServicio}
                                                            onChange={onChange}
                                                            
                                                          
                                                            
                                                            
                                                          />
                                                              {props.error && props.error.detallesServicio ? (
                                                      <Alert color = 'danger' className="mt-2">{props.error.detallesServicio}</Alert>
                                                      ):null}
                                                  </Row>

                                                            {/* Observaciones */}

                                                <Row>

                                                  <Label
                                                        for="observaciones"
                                                        className="col-form-label col-sm-4 d-flex"
                                                      >
                                                    <strong>OBSERVACIONES </strong> 
                                                      </Label>

                                                      <textarea
                                                        className="form-control"
                                                        id="observaciones"
                                                        name="observaciones"
                                                        type="textarea"
                                                        value={observaciones}
                                                        rows="4"
                                                        onChange={onChange}
                                                        
                                                      
                                                        
                                                        
                                                      />
                                                     {props.error && props.error.observaciones ? (
                                                  <Alert color = 'danger' className="mt-2">{props.error.observaciones}</Alert>
                                                  ):null}
                                                </Row>

                                                <Row>

                                                <Label
                                                        for="image_file"
                                                        className="col-form-label col-sm-4 d-flex"
                                                      >
                                                    <strong>IMAGENES (OPCIONAL)</strong> 
                                                      </Label>

                                                      <input
                                                        className="form-control"
                                                        id="image_file"
                                                        name="image_file"
                                                        type="file"
                                                       
                                                        
                                                        onChange={(e) => handleImageChange(e.target.files)}
                                                        />
                                                </Row>


                                                      {/* Grupo de Tecnicos */}
                                                <Row>


                                                <Label
                                                  
                                                  for="grupo_tecnico"
                                                  className="col-form-label col-sm-4 d-flex"
                                                >
                                              <strong>GRUPO DE TECNICOS</strong>
                                                </Label>




                                              
                                                 
                                                  <Select  
                                                     
                                                     id="grupo_tecnico"
                                                     name="grupo_tecnico"
                                                     placeholder ="Seleccione"
                                                     
                                                     onChange={handleSelectGrupoTecnico}
                                                     options ={ Array.isArray(grupotTecnico) ?grupotTecnico.map(item => ({label:item.nombre, value:item.id})):[]}
                                                     
                                                   />
                                                </Row>


                                                  {/* Select con los Tecnicos */}
                                              <Row>

                                              <Label
                                                  
                                                  for="tecnico_asignado"
                                                  className="col-form-label col-sm-4 d-flex"
                                                >
                                              <strong>ASIGNADO A </strong>
                                                </Label>




                                              
                                                 
                                                  <MySelect  
                                                     
                                                     id="tecnico_asignado"
                                                     name="tecnico_asignado"
                                                     placeholder ="Seleccione"
                                                     isMulti
                                                     allowSelectAll
                                                     options ={ sd && sd.map(item => ({label:item.first_name, value:item.id}))}
                                                     onChange={(item) => setFormData({
                                                      ...formData,
                                                      tecnico_asignado : item && item.map( item => item.value)
                                                    })}            
                                                     
                                                   />
                                              </Row>

                                                    <Row>
                                                    {/* Fecha */}
                                                   
                                                      <Col lg={4} className="mb-3">


                                                                                          
                                                          <Label

                                                                  for="tecnico_asignado"
                                                                  className="col-form-label col-sm-8 d-flex"
                                                                >
                                                              <strong>FECHA PARA ASIGNAR </strong>
                                                                </Label>

                                                            <input
                                                                    className="form-control d-block"
                                                                    placeholder="Fecha"
                                                                    
                                                                    onChange={e => onChangeFecha( e)}

                                                                  type="date"

                                                                    />

                                                      </Col>

                                                                      {/* HOra de entrada */}
                                                          <Col lg={4} className="mb-3">


                                                                                                                          
                                                                <Label

                                                                        for="horaentrada"
                                                                        className="col-form-label col-sm-8 d-flex"
                                                                      >
                                                                    <strong>HORA DE ENTRADA </strong> 
                                                                      </Label>

                                                              

                                                                    <Flatpickr
                                                                      className="form-control d-block"
                                                                      placeholder="Hora de Entrada"
                                                                      
                                                                      onInput={onChangeHoraEntrada}

                                                                      options={{
                                                                      
                                                                      enableTime:true,
                                                                  
                                                                      noCalendar:true,
                                                                  
                                                                      dateFormat:"H:i K",
                                                                      minuteIncrement:"15"

                                                                      }}

                                                                      />



                                                                

                                                          </Col>

                                                                      {/* Hora de Salida */}
                                                        <Col lg={4} className="mb-3">


                                                                                                            
                                                        <Label

                                                          for="tecnico_asignado"
                                                          className="col-form-label col-sm-6 d-flex"
                                                        >
                                                        <strong>HORA DE SALIDA </strong> 
                                                        </Label>

                                                        <Flatpickr
                                                        className="form-control d-block"
                                                        placeholder="Hora de Salida"

                                                        onInput={onChangeHoraSalida}

                                                        options={{

                                                        enableTime:true,
                                                    
                                                        noCalendar:true,
                                                  
                                                        dateFormat:"H:i K",
                                                        minuteIncrement:"15"

                                                        }}

                                                        />


                                                          </Col>

                                                    </Row>


                                        <Row className="col-lg-12 justify-content-center">
                                          <Col md={1} className= 'mx-3'>
                                            <Button color="primary" type="submit">
                                              Enviar
                                            </Button>
                                          </Col>
                                          <Col md={1} className= 'mx-3'>
                                          <button
                                              type="button"
                                              className="btn btn-secondary"
                                              onClick={() => {
                                                setCaso_txt("");
                                                setCaso(false)
                                              }}
                                          >
                                              Cerrar
                                          </button>
                                          </Col>
                                        </Row>
                                      </Form>
                                                    


        </div>

            
        
              </Modal>


              {groups.includes("SuperAdmin") || groups.includes("Supervisor") ||  groups.includes( "Operador") || groups.includes("Crear y modificar Cliente") ? (
                 <CardBody>
                    <TabContent className="p-4" activeTab={activeTab}>
                    <TabPane id="telefonos" role="tabpanel" tabId="1">              
                                {groups.includes("SuperAdmin") || groups.includes("Supervisor")
                                ||  groups.includes( "Operador") 
                                || groups.includes("Crear y modificar Cliente")
                                || groups.includes("Cliente") ? (
                                        <Button className="btn btn-primary waves-effect waves-light btn-sm mb-4"
                                        color="success" 
                                        type="submit"
                                        onClick={() => handleAdd("Telefono")}
                                          >
                                          Agregar Nuevo Caso
                                        </Button> 
                                    ):null}       


                                  <ListaCasos
                                  
                                  >

                                  </ListaCasos>
                          </TabPane>
                    </TabContent>
                 </CardBody>
     ):     null }

      </React.Fragment>
    );
}
 
const mapStateToProps = (state) => {
  const { error, loading, casos,casosCreated } = state.Casos;
  return { error, loading,casos, casosCreated };
};

CasosContacto.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  casosCreated: PropTypes.object,
}


 
export default withRouter(connect(mapStateToProps, {casosCreate})(CasosContacto));
